/**
 * RemarkEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { VisitEntity } from "../VisitEntity";
import { RemarkEntity } from "../RemarkEntity";
import { RemarkCategoryHierarchyEntity } from "../RemarkCategoryHierarchyEntity";
import { RemarkStyleEntity } from "../RemarkStyleEntity";
import { PersonEntity } from "../PersonEntity";
import { RemarkAnnotationEntity } from "../RemarkAnnotationEntity";
declare global {
    interface EntityTypeMap {
        Remark: RemarkEntity;
    }
}
export abstract class RemarkGeneratedEntity extends BaseEntity {
    public abstract remarkId: string;
    public abstract templateId: string | null;
    public abstract dueDate: string | null;
    public abstract status: string | null;
    public abstract text: string | null;
    public abstract time: Date | null;
    public abstract hasTaskData: boolean;
    public abstract startDate: Date | null;
    public abstract endDate: Date | null;
    public abstract progress: number | null;
    public abstract creationDate: Date;
    public abstract openDate: Date;
    public abstract closeDate: Date | null;
    public abstract project: ProjectEntity;
    public abstract visit: VisitEntity | null;
    public abstract closeVisit: VisitEntity | null;
    public abstract parentRemark: RemarkEntity | null;
    public abstract categoryHierarchy: RemarkCategoryHierarchyEntity | null;
    public abstract style: RemarkStyleEntity | null;
    public abstract contact: PersonEntity | null;
    public abstract readonly childrenRemarks: ReadonlyArray<RemarkEntity>;
    public abstract readonly annotations: ReadonlyArray<RemarkAnnotationEntity>;
}
